/**
 * - trim whitespace
 * - if no protocol specified, prefix "https://"
 * - remove trailing slash
 */
export default function formatURL(url: string): string {
  url = url.trim();

  if (url.length === 0) return url;

  const protocols = ["http://", "https://"];
  let hasProtocolPrefix = false;
  for (const protocol of protocols) {
    hasProtocolPrefix ||= url.startsWith(protocol);
  }

  if (!hasProtocolPrefix) {
    url = "https://" + url;
  }

  if (url.endsWith("/")) url = url.substring(0, url.length - 1);

  return url;
}
